// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3DjUv","name":"ConsentHeader_name__3w6UE","birthday":"ConsentHeader_birthday__25itN","skeleton":"ConsentHeader_skeleton__1l3rb"};